import { useState } from 'react';
import { Control, useFieldArray, useWatch } from 'react-hook-form';
import { Coverage } from '../../../../../types/AdvisoryReport';
import { InsuranceDetailFormValues } from '../../../types/Form';

export interface Page {
  type: 'INSURANCE' | 'COVERAGE' | 'NEW';
  index?: number;
}

export interface InsurancePolicyModalProps {
  page: Page;
  setPage: (p: Page) => void;
  coverages: Coverage[];
  handleRemoveCoverage: (ids: string[]) => void;
}

// This component should only be used inside the form context of the Insurance modal
const useInsurancePolicyModal = (
  control: Control<InsuranceDetailFormValues>,
  initialPage?: Page,
): InsurancePolicyModalProps => {
  const { remove } = useFieldArray({ control, name: 'coverages' });
  const coverages = useWatch({ control, name: 'coverages' }) || [];

  const [page, setPage] = useState<Page>(
    initialPage || {
      type: 'INSURANCE',
    },
  );

  const handleRemoveCoverage = (coverageIds: string[]) => {
    const indexOfCoverages = coverageIds.map((_id) =>
      coverages.findIndex(({ id }) => id === _id),
    );
    remove(indexOfCoverages);
    setPage({ type: 'INSURANCE' });
  };

  return {
    page,
    setPage,
    coverages,
    handleRemoveCoverage,
  };
};

export default useInsurancePolicyModal;
